/**
 * gt-pdp-buybox — syncs pack / mode / frequency into Horizon form inputs + live prices.
 * Cart add stays on product-form-component; this element does not POST to cart.
 */
(function () {
    if (customElements.get('gt-pdp-buybox')) return;
  
    class GtPdpBuybox extends HTMLElement {
      connectedCallback() {
        if (this._gtConnected) return;
        this._gtConnected = true;
        this._abort = new AbortController();
        var signal = this._abort.signal;
  
        this.sellingPlanInput = this.querySelector('[data-gt-selling-plan-input]');
        this.priceOnetime = Array.from(this.querySelectorAll('[data-gt-price-onetime]'));
        this.priceSubscribe = Array.from(this.querySelectorAll('[data-gt-price-subscribe]'));
        this.compareOnetime = Array.from(this.querySelectorAll('[data-gt-compare-onetime]'));
        this.compareSubscribe = Array.from(this.querySelectorAll('[data-gt-compare-subscribe]'));
        this.frequencyChips = this.querySelector('[data-gt-frequency-chips]');
        this.shipBar = this.querySelector('[data-gt-ship-bar]');
        this.planInputs = Array.from(this.querySelectorAll('input[data-gt-plan]'));
        this.modeInputs = Array.from(this.querySelectorAll('input[data-gt-mode]'));
        this.frequencyWrap = this.querySelector('[data-gt-frequency-wrap]');
        this.frequencySelect = this.querySelector('[data-gt-frequency-select]');
        this.atcButton = this.querySelector('[data-gt-atc-button]');
  
        var root = this.closest('.gt-pdp-hero');
        this.stickyPack = root ? root.querySelector('[data-gt-sticky-pack]') : null;
        this.stickyTotalOnetime = root ? root.querySelector('[data-gt-sticky-total-onetime]') : null;
        this.stickyTotalSubscribe = root ? root.querySelector('[data-gt-sticky-total-subscribe]') : null;
        this.stickyCompareOnetime = root ? root.querySelector('[data-gt-sticky-compare-onetime]') : null;
        this.stickyCompareSubscribe = root ? root.querySelector('[data-gt-sticky-compare-subscribe]') : null;
  
        this.galleryImgDesktop = null;
        this.galleryImgMobile = null;
        this.galleryFirstImg = null;
        if (root) {
          var gallery = root.querySelector('.gt-pdp-hero__gallery');
          /* Pack changes swap the variant-hero slide only; an optional landing slide sits before it and must stay put. */
          if (gallery && gallery.classList.contains('gt-pdp-hero__gallery--split')) {
            this.galleryImgDesktop = gallery.querySelector('.gt-pdp-hero__cell--desktop[data-gt-variant-hero] .gt-pdp-hero__img');
            this.galleryImgMobile = gallery.querySelector('.gt-pdp-hero__cell--mobile[data-gt-variant-hero] .gt-pdp-hero__img');
          } else if (gallery) {
            this.galleryFirstImg =
              gallery.querySelector('[data-gt-variant-hero] .gt-pdp-hero__img') ||
              gallery.querySelector('.gt-pdp-hero__cell:not([data-gt-landing-hero]) .gt-pdp-hero__img');
          }
        }
        function storeOrig(el, keySrc, keySrcset) {
          if (!el) return;
          this[keySrc] = el.getAttribute('src');
          this[keySrcset] = el.getAttribute('srcset');
        }
        storeOrig.call(this, this.galleryImgDesktop, '_galleryOrigDesktopSrc', '_galleryOrigDesktopSrcset');
        storeOrig.call(this, this.galleryImgMobile, '_galleryOrigMobileSrc', '_galleryOrigMobileSrcset');
        storeOrig.call(this, this.galleryFirstImg, '_galleryOrigSrc', '_galleryOrigSrcset');
  
        this._onChange = this.sync.bind(this);
        this._onFrequency = this.onFrequencyChange.bind(this);
  
        this.planInputs.forEach(function (i) {
          i.addEventListener('change', this._onChange, { signal: signal });
        }, this);
        this.modeInputs.forEach(function (i) {
          i.addEventListener('change', this._onChange, { signal: signal });
        }, this);
        if (this.frequencySelect) {
          this.frequencySelect.addEventListener('change', this._onFrequency, { signal: signal });
        }
        if (this.frequencyChips) {
          this.frequencyChips.addEventListener('click', function (e) {
            var chip = e.target.closest('[data-plan-id]');
            if (!chip || !this.frequencySelect) return;
            this.frequencySelect.value = chip.dataset.planId;
            this.onFrequencyChange();
          }.bind(this), { signal: signal });
        }
  
        this.sync();
      }
  
      disconnectedCallback() {
        if (this._abort) this._abort.abort();
        this._gtConnected = false;
      }
  
      get mode() {
        var m = this.modeInputs.find(function (i) {
          return i.checked;
        });
        return m ? m.dataset.gtMode : 'subscribe';
      }
  
      getPlansForInput(plan) {
        try {
          return JSON.parse(plan.getAttribute('data-selling-plans') || '[]');
        } catch (e) {
          return [];
        }
      }
  
      populateFrequencySelect(plan, subscribe) {
        if (!this.frequencyWrap || !this.frequencySelect) return;
        if (!subscribe) {
          this.frequencyWrap.hidden = true;
          return;
        }
        var plans = this.getPlansForInput(plan);
        if (plans.length <= 1) {
          this.frequencyWrap.hidden = true;
          return;
        }
        this.frequencyWrap.hidden = false;
        var selectedId = plan.dataset.sellingPlan || '';
        var same =
          this.frequencySelect.options.length === plans.length &&
          Array.prototype.every.call(this.frequencySelect.options, function (opt, i) {
            return String(opt.value) === String(plans[i].id);
          });
        if (!same) {
          this.frequencySelect.innerHTML = '';
          plans.forEach(function (p) {
            var opt = document.createElement('option');
            opt.value = p.id;
            opt.textContent = p.name;
            this.frequencySelect.appendChild(opt);
          }, this);
        }
        this.frequencySelect.value = selectedId;
        this.renderFrequencyChips(plan, plans, selectedId);
      }

      renderFrequencyChips(plan, plans, selectedId) {
        var wrap = this.frequencyChips;
        if (!wrap) return;
        var recommendedId = plan.dataset.defaultSellingPlan || '';
        var recommendedLabel = wrap.dataset.recommendedLabel || '';
        var strip = wrap.dataset.strip || '';
        wrap.textContent = '';
        plans.forEach(function (p) {
          var chip = document.createElement('button');
          chip.type = 'button';
          chip.className = 'gt-nbb__chip gt-body-sm';
          chip.dataset.planId = p.id;
          chip.setAttribute('aria-pressed', String(String(p.id) === String(selectedId)));
          var name = document.createElement('span');
          name.textContent = strip ? String(p.name).replace(strip, '') : p.name;
          chip.appendChild(name);
          if (recommendedLabel && String(p.id) === String(recommendedId)) {
            var tag = document.createElement('span');
            tag.className = 'gt-nbb__chip-tag gt-label-xs';
            tag.textContent = recommendedLabel;
            chip.appendChild(tag);
          }
          wrap.appendChild(chip);
        });
      }

      formatCents(cents) {
        var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
        var amount = cents / 100;
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
            style: 'currency',
            currency: currency,
            minimumFractionDigits: amount % 1 === 0 ? 0 : 2
          }).format(amount);
        } catch (e) {
          return amount.toFixed(2);
        }
      }

      syncShipBar(plan, subscribe) {
        var bar = this.shipBar;
        if (!bar || !plan) return;
        var price = parseInt(
          subscribe ? plan.dataset.priceSubscribeCents || plan.dataset.priceOnetimeCents || '0' : plan.dataset.priceOnetimeCents || '0',
          10
        );
        var min = parseInt(subscribe ? this.dataset.shipSubscribeMin || '1500' : this.dataset.shipOnetimeMin || '3500', 10);
        var left = min - price;
        var text = bar.querySelector('[data-gt-ship-text]');
        var fill = bar.querySelector('[data-gt-ship-fill]');
        if (text) {
          text.textContent = left > 0
            ? (bar.dataset.away || '[amount]').replace('[amount]', this.formatCents(left))
            : bar.dataset.done || '';
        }
        if (fill) fill.style.width = (min > 0 && left > 0 ? Math.round((price / min) * 100) : 100) + '%';
      }
  
      applySellingPlan(plan, sp) {
        if (!sp) return;
        plan.dataset.sellingPlan = sp.id;
        plan.dataset.priceSubscribe = sp.price;
        plan.dataset.priceSubscribeCents = String(sp.priceCents);
        plan.dataset.compareSubscribe = sp.compare && sp.compare !== sp.price ? sp.compare : '';
  
        var card = plan.closest('.gt-plan-card');
        if (!card) return;
        var priceEl = card.querySelector('.gt-plan-card__price--subscribe');
        var compareEl = card.querySelector('.gt-plan-card__compare--subscribe');
        if (priceEl) priceEl.textContent = sp.price;
        if (compareEl) compareEl.textContent = sp.compare && sp.compare !== sp.price ? sp.compare : '';
      }
  
      onFrequencyChange() {
        var plan = this.planInputs.find(function (i) {
          return i.checked;
        });
        if (!plan || !this.frequencySelect || this.mode !== 'subscribe') return;
        var selectedId = this.frequencySelect.value;
        var sp = this.getPlansForInput(plan).find(function (p) {
          return String(p.id) === String(selectedId);
        });
        if (!sp) return;
        this.applySellingPlan(plan, sp);
        this.sync();
      }
  
      syncAtcLabel(plan, subscribe) {
        if (!this.atcButton) return;
        if (this.atcButton.hasAttribute('data-gt-atc-dynamic') && plan) {
          var label = subscribe ? this.atcButton.dataset.labelSubscribe : this.atcButton.dataset.labelOnetime;
          var price = subscribe ? plan.dataset.priceSubscribe || plan.dataset.priceOnetime : plan.dataset.priceOnetime;
          this.atcButton.textContent = label + (price ? ' · ' + price : '');
          return;
        }
        var direct = this.dataset.directCheckout === 'true';
        this.atcButton.textContent = direct
          ? this.dataset.buyNowLabel || 'Buy now'
          : this.dataset.atcLabel || 'Add to cart';
      }
  
      setMoney(el, value, other) {
        if (!el) return;
        el.textContent = value && value !== other ? value : value || '';
      }
  
      syncShippingLabel(plan, subscribe) {
        var shippingLabel = this.querySelector('[data-gt-trust-shipping-label]');
        if (!shippingLabel || !plan) return;
        var priceCents = subscribe
          ? parseInt(plan.dataset.priceSubscribeCents || plan.dataset.priceOnetimeCents || '0', 10)
          : parseInt(plan.dataset.priceOnetimeCents || '0', 10);
        var onetimeMin = parseInt(this.dataset.shipOnetimeMin || '3500', 10);
        var subscribeMin = parseInt(this.dataset.shipSubscribeMin || '1500', 10);
        var qualified = this.dataset.shipLabel || 'Free shipping';
        var belowOnetime = this.dataset.shipOnetimeBelow || 'Free shipping on £35+';
        var belowSubscribe = this.dataset.shipSubscribeBelow || 'Free shipping on £15+';
        if (subscribe) {
          shippingLabel.textContent = priceCents >= subscribeMin ? qualified : belowSubscribe;
        } else {
          shippingLabel.textContent = priceCents >= onetimeMin ? qualified : belowOnetime;
        }
      }
  
      sync() {
        var plan = this.planInputs.find(function (i) {
          return i.checked;
        });
        if (!plan) return;
        var subscribe = this.mode === 'subscribe';
        var variantId = plan.dataset.variantId || plan.value;
  
        var refInput = this.querySelector('[data-gt-variant-id-input]');
        if (refInput) refInput.value = variantId;
  
        var sp = plan.dataset.sellingPlan;
        if (this.sellingPlanInput) {
          if (subscribe && sp) {
            this.sellingPlanInput.value = sp;
            this.sellingPlanInput.disabled = false;
          } else {
            this.sellingPlanInput.value = '';
            this.sellingPlanInput.disabled = true;
          }
        }
  
        var priceOnetime = plan.dataset.priceOnetime || '';
        var compareOnetime = plan.dataset.compareOnetime || '';
        var priceSubscribe = plan.dataset.priceSubscribe || priceOnetime;
        var compareSubscribe = plan.dataset.compareSubscribe || '';
  
        this.priceOnetime.forEach(function (el) { el.textContent = priceOnetime; });
        this.priceSubscribe.forEach(function (el) { el.textContent = priceSubscribe; });
        this.compareOnetime.forEach(function (el) {
          el.textContent = compareOnetime && compareOnetime !== priceOnetime ? compareOnetime : '';
        });
        this.compareSubscribe.forEach(function (el) {
          el.textContent = compareSubscribe && compareSubscribe !== priceSubscribe ? compareSubscribe : '';
        });
  
        if (this.stickyPack && plan.dataset.planName) this.stickyPack.textContent = plan.dataset.planName;
        if (this.stickyTotalOnetime) this.stickyTotalOnetime.textContent = priceOnetime;
        if (this.stickyTotalSubscribe) this.stickyTotalSubscribe.textContent = priceSubscribe;
        if (this.stickyCompareOnetime) {
          this.stickyCompareOnetime.textContent =
            compareOnetime && compareOnetime !== priceOnetime ? compareOnetime : '';
        }
        if (this.stickyCompareSubscribe) {
          this.stickyCompareSubscribe.textContent =
            compareSubscribe && compareSubscribe !== priceSubscribe ? compareSubscribe : '';
        }
  
        var applyGalleryImg = function (el, url, origSrc, origSrcset) {
          if (!el) return;
          if (url) {
            el.src = url;
            el.removeAttribute('srcset');
          } else if (origSrc) {
            el.src = origSrc;
            if (origSrcset) el.setAttribute('srcset', origSrcset);
            else el.removeAttribute('srcset');
          }
        };
  
        /* Slide 1 is always the variant hero image for the selected pack.
           These data attributes may come from explicit pack overrides or the
           variant featured media fallback, so swapping here is always correct. */
        if (this.galleryImgDesktop || this.galleryImgMobile) {
          applyGalleryImg(
            this.galleryImgDesktop,
            plan.getAttribute('data-variant-image'),
            this._galleryOrigDesktopSrc,
            this._galleryOrigDesktopSrcset
          );
          applyGalleryImg(
            this.galleryImgMobile,
            plan.getAttribute('data-variant-image-mobile') || plan.getAttribute('data-variant-image'),
            this._galleryOrigMobileSrc,
            this._galleryOrigMobileSrcset
          );
        } else if (this.galleryFirstImg) {
          var isMobile = window.matchMedia('(max-width: 989px)').matches;
          var vimg = isMobile
            ? plan.getAttribute('data-variant-image-mobile') || plan.getAttribute('data-variant-image')
            : plan.getAttribute('data-variant-image');
          applyGalleryImg(this.galleryFirstImg, vimg, this._galleryOrigSrc, this._galleryOrigSrcset);
        }
  
        if (this.atcButton) this.atcButton.disabled = !!plan.disabled;
        if (this._synced) this.resetGalleryScroll();
        this._synced = true;
        this.populateFrequencySelect(plan, subscribe);
        this.syncAtcLabel(plan, subscribe);
        this.syncShippingLabel(plan, subscribe);
        this.syncShipBar(plan, subscribe);
      }
  
      /* mobile carousel (<=480): after a pack change show the variant-hero slide (not the landing slide) */
      resetGalleryScroll() {
        var hero = this.closest('.gt-pdp-hero');
        if (!hero || !window.matchMedia('(max-width: 480px)').matches) return;
        var gallery = hero.querySelector('.gt-pdp-hero__gallery');
        if (!gallery) return;
        var target = Array.prototype.find.call(
          gallery.querySelectorAll('[data-gt-variant-hero]'),
          function (cell) { return cell.offsetParent !== null; }
        );
        gallery.scrollLeft = target ? target.offsetLeft - gallery.offsetLeft : 0;
        gallery.dispatchEvent(new Event('scroll'));
      }
    }
  
    customElements.define('gt-pdp-buybox', GtPdpBuybox);
  })();
  